import { client } from '~/api/client'
import { postCoordinatesCoordinateIdDynamicLinksV1 } from '~/api/gen'
import { assertSuccess } from '~/lib/assertSuccess'

export const getDynamicLinkByCoordinateId = async (
  coordinateId: number,
  fallbackUrl: string | null = null,
  timeZone = 'Asia/Tokyo'
): Promise<string | undefined> => {
  try {
    if (!Number.isFinite(coordinateId) || coordinateId <= 0)
      throw new Error('Invalid coordinateId.')
    const result = await postCoordinatesCoordinateIdDynamicLinksV1(client, {
      parameter: {
        coordinate_id: coordinateId.toString(),
        'x-wr-time-zone': timeZone,
      },
      requestBody: { fallback_link: fallbackUrl },
    })
    assertSuccess(result)
    return result.data.short_url
  } catch {
    return undefined
  }
}
